import './footer.scss';

import React from 'react';
import { Col, Row } from 'reactstrap';

import appConfig from 'app/config/constants';

const Footer = props => (
  <div className="footer page-content">
    <Row>
      <Col md="12">
        <p>
          &#169; 2021 SPB <span className="version">{appConfig.VERSION}</span>
        </p>
      </Col>
    </Row>
  </div>
);

export default Footer;
